module.exports = __webpack_public_path__ + "static/media/feature-documentation-management.cef72f42.png";